package nl.volleyplanner.web.util

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.format.DayOfWeekNames
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.format.char

val DAY_NAMES_LONG = DayOfWeekNames("maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag")
val DAY_NAMES_SHORT = DayOfWeekNames("ma", "di", "wo", "do", "vr", "za", "zo")
val MONTH_NAMES_LONG = MonthNames("januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december")
val MONTH_NAMES_SHORT = MonthNames("jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec")

object LocalDateTimeFormatters {
    val DAY_MONTH_YEAR_TIME_TEXT_SHORT = LocalDateTime.Format { day(); char(' '); monthName(MONTH_NAMES_SHORT); char(' '); year(); char(' '); hour(); char(':'); minute() }
}

object LocalDateFormatters {
    val DD_MM_YYYY_NUMBERS = LocalDate.Format { day(); char('-'); monthNumber(); char('-'); year() }
    val YYYY_MM_DD_NUMBERS = LocalDate.Format { year(); char('-'); monthNumber(); char('-'); day(); }
}

object LocalTimeFormatters {
    val HOUR_MINUTE_FORMAT = LocalTime.Format { hour(); char(':'); minute() }
}